import { render, staticRenderFns } from "./CollaboratoreDetails.vue?vue&type=template&id=72c7b42f"
import script from "./CollaboratoreDetails.vue?vue&type=script&lang=js"
export * from "./CollaboratoreDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports